// BrandSection.jsx

import React, { useRef, useState, useEffect } from "react";
import styles from "./BrandSection.module.css";
import { FaDownload } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { getImageUrl } from "../../MIS/Global";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../MIS/encryption";


export default function BrandSection({ title = "RN", products = [],isSection="" }) {
  const navigate= useNavigate();
  const scrollRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 992);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const updateDeviceType = () => {
      setIsDesktop(window.innerWidth > 992);
      checkScrollable();
    };

    window.addEventListener("resize", updateDeviceType);
    updateDeviceType();
    return () => window.removeEventListener("resize", updateDeviceType);
  }, []);

  const checkScrollable = () => {
    if (!scrollRef.current) return;
    const el = scrollRef.current;
    setIsScrollable(el.scrollWidth > el.clientWidth + 5);
  };

  const scrollOneCard = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    const card = el.querySelector(`.${styles.card}`);
    const cardWidth = card ? card.offsetWidth + 16 : 190;

    el.scrollBy({
      left: direction === "left" ? -cardWidth : cardWidth,
      behavior: "smooth"
    });
  };

  const updateScrollProgress = () => {
    const el = scrollRef.current;
    if (!el) return;

    const progress = (el.scrollLeft / (el.scrollWidth - el.clientWidth)) * 100;
    setScrollProgress(progress);
  };

  useEffect(() => {
    checkScrollable();
  }, [products]);

  const handle_navigate=(element)=>{
   if(isSection=="home"){
    return `/subcategory/${encrypt(element?.id)}/${element?.productName}`;
   }
   return "";
  }

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.headerBox}>
        <input disabled type="checkbox" className={styles.checkbox} />
        <span className={styles.headerTitle}>{title}</span>
        {/* <FaDownload className={styles.downloadIcon} /> */}
      </div>
      

      {isDesktop && isScrollable && (
        <>
          <button
            className={`${styles.navBtn} ${styles.leftBtn}`}
            onClick={() => scrollOneCard("left")}
          >
            <FaChevronLeft />
          </button>

          <button
            className={`${styles.navBtn} ${styles.rightBtn}`}
            onClick={() => scrollOneCard("right")}
          >
            <FaChevronRight />
          </button>
        </>
      )}

      <div
        className={styles.scrollContainer}
        ref={scrollRef}
        onScroll={updateScrollProgress}        
      >
        {products.map((item, index) => (
          <div key={index} className={styles.card}
          onClick={()=>{
            navigate(handle_navigate(item))
          }}
          >
          
            <img 
            src={getImageUrl(`/media/${item?.imgpath}`)}
            alt="" className={styles.productImg} />

            {/* <div className={styles.stock}>STOCK {item.stock}</div> */}

            <div className={styles.nameBox}>
              <div className={styles.code}>{item?.productName}</div>
              {/* <div className={styles.dn}>{item.dn}</div> */}
              {/* <div className={styles.mrp}>MRP Rs.{item.mrp}</div> */}
              {/* <div className={styles.color}>{item.color}</div> */}
            </div>
            <div className={styles.viewIndicator}>View →</div>
          </div>
        ))}
      </div>

      {isScrollable && (
        <div className={styles.progressBarWrapper}>
          <div
            className={styles.progressFill}
            style={{ width: `${scrollProgress}%` }}
          ></div>
        </div>
      )}
    </div>
  );
}
